import { InputBase } from "./_InputBase";

/**
 * Controller behind form control which edits/displays holiday pay calculation multipliers.
 */

export class InputHolidayMultipliersController extends InputBase<any> {

  /** Set the values and defaults on init */
  public $onInit() {
    super.$onInit();
  }

  /** Delete one multiplier */
  public delete(key: string) {
    delete this.value[key];
    this.onChange();
  }

  /** Add one multiplier */
  public createNew() {
    let newKey = 1;
    if (!this.value) {
      this.value = {};
    }
    for(const key in this.value) {
      const keyValue = Number.parseInt(key);
      if ( keyValue >= newKey) {
        newKey = keyValue + 1;
      }
    }
    this.value[newKey] = 0;
    this.onChange();
  }

  /** On key changed event. */
  public onKeyChanged(key: string, newKey: string) {
    if (key !== newKey) {
      const value = this.value[key];
      delete this.value[key];
      this.value[newKey] = value;
    }
    this.onChange();
  }
}
